var render = function () {
  var _vm$coupon$list_butto, _vm$coupon;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "coupon-card"
  }, [_c('div', {
    staticClass: "coupon-card__wrapper"
  }, [_c('div', {
    staticClass: "coupon-card__image"
  }, [_vm.image ? _c('img', {
    attrs: {
      "src": _vm.image
    }
  }) : _c('svg', {
    attrs: {
      "width": "75",
      "height": "60",
      "viewBox": "0 0 75 60",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_1244_1530)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M46.6813 11.5587C46.322 10.7511 45.9618 9.94258 45.6025 9.135C45.4205 8.72582 44.8233 8.62891 44.467 8.83741C44.0451 9.08409 43.9864 9.56179 44.1694 9.97292C44.5287 10.7805 44.8889 11.5891 45.2482 12.3967C45.4302 12.8058 46.0274 12.9027 46.3837 12.6942C46.8056 12.4476 46.8643 11.9699 46.6813 11.5587Z",
      "fill": "#C0C4CC"
    }
  }), _c('path', {
    attrs: {
      "d": "M49.0826 16.9544L48.0039 14.5306C47.8218 14.1215 47.2247 14.0245 46.8684 14.233C46.4465 14.4797 46.3878 14.9574 46.5708 15.3686L47.6495 17.7923C47.8316 18.2015 48.4287 18.2984 48.785 18.0899C49.207 17.8432 49.2657 17.3655 49.0826 16.9544Z",
      "fill": "#C0C4CC"
    }
  }), _c('path', {
    attrs: {
      "d": "M51.485 22.349L50.4062 19.9253C50.2242 19.5161 49.627 19.4192 49.2707 19.6277C48.8488 19.8744 48.7901 20.3521 48.9731 20.7632L50.0519 23.1869C50.234 23.5961 50.8311 23.693 51.1874 23.4845C51.6093 23.2378 51.668 22.7601 51.485 22.349Z",
      "fill": "#C0C4CC"
    }
  }), _c('path', {
    attrs: {
      "d": "M31.1482 25.6821L39.9651 21.7568C40.3762 21.5737 40.7883 21.3907 41.1995 21.2076C41.6087 21.0255 41.7056 20.4284 41.4971 20.0721C41.2504 19.6502 40.7727 19.5915 40.3615 19.7745L31.5447 23.6999C31.1336 23.8829 30.7215 24.066 30.3103 24.249C29.9011 24.4311 29.8042 25.0282 30.0127 25.3845C30.2594 25.8064 30.7371 25.8652 31.1482 25.6821Z",
      "fill": "#C0C4CC"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.576 49.932C10.5472 47.6218 9.51938 45.3116 8.49056 43.0014C6.77653 39.1515 5.0625 35.3015 3.34748 31.4505C2.87566 30.3914 2.40481 29.3332 1.93299 28.2741C1.89873 28.1967 1.86251 28.1204 1.83021 28.043C1.82825 28.0381 1.82629 28.0342 1.82433 28.0293C1.90656 28.2271 1.74113 27.766 1.72938 27.7229C1.64617 27.4126 1.61877 27.0818 1.65988 26.7617C1.78126 25.8112 2.41167 25.0976 3.25938 24.706C4.5985 24.0864 5.9572 23.5049 7.30513 22.9048C10.3759 21.5373 13.4467 20.1708 16.5175 18.8033C20.4692 17.0442 24.42 15.2842 28.3718 13.5251C32.3627 11.7485 36.3536 9.97079 40.3456 8.19411C43.5348 6.77374 46.725 5.35435 49.9142 3.93398C51.4618 3.24485 53.0153 2.5655 54.559 1.86657C54.5933 1.85091 54.6275 1.83525 54.6628 1.82056C54.5208 1.88028 54.7763 1.78141 54.8507 1.75791C55.1933 1.65122 55.5516 1.60814 55.9099 1.65024C56.9514 1.77064 57.6464 2.47446 58.0576 3.38972C58.825 5.1018 59.5837 6.81779 60.3472 8.53183C60.5586 9.00659 60.7701 9.48135 60.9815 9.95611C61.0246 9.62133 61.0676 9.28557 61.1117 8.95079C59.0668 11.2786 59.4838 14.8202 60.7681 17.4103C61.9036 19.7 64.1345 21.8829 66.8372 21.9113C66.5984 21.7742 66.3595 21.6372 66.1207 21.5001C66.7119 22.8275 67.3032 24.1549 67.8934 25.4832C68.0755 25.8924 68.6726 25.9893 69.0289 25.7808C69.4509 25.5341 69.5096 25.0564 69.3265 24.6453C68.7353 23.3179 68.144 21.9906 67.5538 20.6622C67.4383 20.4018 67.1054 20.254 66.8372 20.2511C64.7806 20.2295 63.1478 18.4059 62.2727 16.7144C61.2987 14.83 60.7378 11.8845 62.2844 10.1245C62.5536 9.81808 62.5742 9.47841 62.4146 9.11916C61.7333 7.58916 61.052 6.05915 60.3707 4.52915C60.0662 3.84393 59.7648 3.15773 59.4564 2.47446C58.92 1.28805 57.85 0.373766 56.5697 0.0889097C54.6892 -0.329076 52.7588 0.863211 51.0849 1.60912C48.2452 2.87287 45.4064 4.13759 42.5667 5.40134C38.6423 7.14865 34.7189 8.89597 30.7945 10.6423C26.6813 12.4738 22.567 14.3053 18.4537 16.1368C15.0383 17.657 11.623 19.1782 8.20767 20.6984C6.37812 21.5129 4.54956 22.3273 2.72002 23.1417C1.33195 23.7594 0.271815 24.8949 0.0437343 26.4474C-0.155959 27.8032 0.414733 28.9162 0.942354 30.1007C2.51053 33.6227 4.07871 37.1457 5.64689 40.6678C7.06824 43.8599 8.48958 47.0531 9.91093 50.2462L10.1449 50.7728C10.327 51.182 10.9241 51.2789 11.2804 51.0704C11.7023 50.8237 11.761 50.346 11.578 49.9349L11.576 49.932Z",
      "fill": "#C0C4CC"
    }
  }), _c('path', {
    attrs: {
      "d": "M59.3672 31.6299V28.9771C59.3672 27.9091 57.707 27.9071 57.707 28.9771V31.6299C57.707 32.6978 59.3672 32.6998 59.3672 31.6299Z",
      "fill": "#C0C4CC"
    }
  }), _c('path', {
    attrs: {
      "d": "M59.3672 37.5355V34.8827C59.3672 33.8147 57.707 33.8128 57.707 34.8827V37.5355C57.707 38.6035 59.3672 38.6054 59.3672 37.5355Z",
      "fill": "#C0C4CC"
    }
  }), _c('path', {
    attrs: {
      "d": "M59.3672 43.4411V40.7883C59.3672 39.7204 57.707 39.7184 57.707 40.7883V43.4411C57.707 44.5091 59.3672 44.511 59.3672 43.4411Z",
      "fill": "#C0C4CC"
    }
  }), _c('path', {
    attrs: {
      "d": "M59.3672 49.3468V46.694C59.3672 45.626 57.707 45.624 57.707 46.694V49.3468C57.707 50.4147 59.3672 50.4167 59.3672 49.3468Z",
      "fill": "#C0C4CC"
    }
  }), _c('path', {
    attrs: {
      "d": "M59.3672 55.2524V52.5996C59.3672 51.5316 57.707 51.5297 57.707 52.5996V55.2524C57.707 56.3204 59.3672 56.3223 59.3672 55.2524Z",
      "fill": "#C0C4CC"
    }
  }), _c('path', {
    attrs: {
      "d": "M41.4836 42.398C40.2956 42.398 39.3936 42.816 38.7776 43.696C38.2056 44.444 37.9416 45.456 37.9416 46.71C37.9416 47.942 38.2056 48.932 38.7776 49.724C39.3936 50.56 40.2956 51 41.4836 51C42.6496 51 43.5516 50.56 44.1896 49.724C44.7396 48.954 45.0256 47.942 45.0256 46.71C45.0256 45.456 44.7396 44.444 44.1896 43.696C43.5516 42.816 42.6496 42.398 41.4836 42.398ZM39.5916 34.984L30.7696 51.308H32.1996L40.9996 34.984H39.5916ZM30.3076 35.292C29.1196 35.292 28.2176 35.71 27.6016 36.59C27.0296 37.338 26.7656 38.35 26.7656 39.604C26.7656 40.836 27.0296 41.826 27.6016 42.618C28.2176 43.454 29.1196 43.894 30.3076 43.894C31.4736 43.894 32.3756 43.454 33.0136 42.618C33.5636 41.848 33.8496 40.836 33.8496 39.604C33.8496 38.35 33.5636 37.338 33.0136 36.59C32.3756 35.71 31.4736 35.292 30.3076 35.292ZM41.4836 43.586C42.1436 43.586 42.6276 43.894 42.9576 44.532C43.2216 45.06 43.3756 45.786 43.3756 46.71C43.3756 47.612 43.2216 48.316 42.9576 48.844C42.6276 49.482 42.1436 49.812 41.4836 49.812C40.8016 49.812 40.3176 49.482 40.0096 48.866C39.7236 48.338 39.5916 47.612 39.5916 46.71C39.5916 45.764 39.7236 45.038 40.0096 44.51C40.3176 43.894 40.8016 43.586 41.4836 43.586ZM30.3076 36.48C30.9676 36.48 31.4516 36.788 31.7596 37.426C32.0456 37.954 32.1996 38.68 32.1996 39.604C32.1996 40.506 32.0456 41.21 31.7816 41.738C31.4516 42.376 30.9676 42.706 30.3076 42.706C29.6256 42.706 29.1416 42.376 28.8336 41.76C28.5476 41.232 28.4156 40.506 28.4156 39.604C28.4156 38.658 28.5476 37.932 28.8336 37.404C29.1416 36.788 29.6256 36.48 30.3076 36.48Z",
      "fill": "#C0C4CC"
    }
  }), _c('path', {
    attrs: {
      "d": "M69.8351 41.8889C69.8576 44.5319 70.8894 47.7338 73.4815 48.9212C73.3444 48.6823 73.2074 48.4435 73.0703 48.2046V54.9022C73.0703 55.5091 73.0977 56.1004 72.8256 56.6662C72.3283 57.6979 71.325 58.109 70.2462 58.109H14.428C13.1114 58.109 11.924 57.3201 11.7136 55.9477C11.6245 55.3672 11.6901 54.7309 11.6901 54.1485V29.5089C11.6901 28.8892 11.6118 28.1737 11.7704 27.5697C12.1012 26.3098 13.2181 25.6628 14.4555 25.6628H70.2766C71.4248 25.6628 72.4967 26.1787 72.9157 27.322C73.1134 27.8594 73.0703 28.4311 73.0703 28.993V35.5682C73.2074 35.3293 73.3444 35.0905 73.4815 34.8516C70.8874 36.04 69.8576 39.2439 69.8351 41.8879C69.8263 42.9558 71.4855 42.9568 71.4953 41.8879C71.5129 39.7843 72.2461 37.2342 74.3194 36.2847C74.5778 36.1663 74.7305 35.8374 74.7305 35.5682V28.7561C74.7305 27.9769 74.6845 27.232 74.3654 26.5017C73.6645 24.8993 72.0748 24.0065 70.3647 24.0026C69.8508 24.0016 69.3368 24.0026 68.8229 24.0026H18.6285C17.2012 24.0026 15.774 23.9967 14.3468 24.0026C12.4203 24.0104 10.6681 25.2262 10.1699 27.1282C9.97116 27.8859 10.0309 28.7091 10.0309 29.4863V54.3726C10.0309 55.2321 9.96627 56.1327 10.2658 56.953C10.905 58.7042 12.5251 59.7624 14.3683 59.7683C14.8676 59.7702 15.3668 59.7683 15.866 59.7683H65.992C67.4574 59.7683 68.9218 59.7732 70.3872 59.7683C72.2275 59.7614 73.8613 58.7091 74.4956 56.953C74.7364 56.2864 74.7305 55.5962 74.7305 54.9012V48.2037C74.7305 47.9335 74.5778 47.6056 74.3194 47.4871C72.2481 46.5386 71.5129 43.9905 71.4953 41.8879C71.4865 40.8199 69.8263 40.818 69.8351 41.8879V41.8889Z",
      "fill": "#C0C4CC"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1244_1530"
    }
  }, [_c('rect', {
    attrs: {
      "width": "74.7303",
      "height": "60",
      "fill": "white"
    }
  })])])])]), _c('div', {
    staticClass: "coupon-card__content",
    class: _vm.backgroundClass
  }, [_c('div', {
    staticClass: "coupon-card__date"
  }, [_vm._v(_vm._s(_vm.startAt) + " ~ " + _vm._s(_vm.endAt))]), _c('div', {
    staticClass: "coupon-card__title text-truncate"
  }, [_vm._v(_vm._s(_vm.coupon.name))]), _c('div', {
    staticClass: "coupon-card__subtitle text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.showCode && !_vm.isHideCode ? _vm.coupon.code : "") + " ")]), _c('div', {
    staticClass: "coupon-card__bottom s-flex s-items-center s-justify-end"
  }, [_vm.isRedeemed ? _c('div', {
    staticClass: "coupon-card__redeemed"
  }, [_c('img', {
    attrs: {
      "src": require("@/pages/Dashboard/Point/stamp-redeemed.png")
    }
  })]) : _c('div', {
    staticClass: "coupon-card__button"
  }, [_vm.showButton ? _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs btn-exchange",
    attrs: {
      "type": "button",
      "disabled": !((_vm$coupon$list_butto = (_vm$coupon = _vm.coupon) === null || _vm$coupon === void 0 ? void 0 : _vm$coupon.list_button_clickable) !== null && _vm$coupon$list_butto !== void 0 ? _vm$coupon$list_butto : true)
    },
    on: {
      "click": function click($event) {
        return _vm.handleExchange(_vm.coupon);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]) : _vm._e()])])])])]), _c('svg', {
    staticClass: "svg position-absolute",
    staticStyle: {
      "height": "0"
    }
  }, [_c('clipPath', {
    attrs: {
      "id": "my-clip-path",
      "clipPathUnits": "objectBoundingBox"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.968,0.5 c0,0.054,0.014,0.098,0.032,0.098 c0,0,0,0,0,0 V1 H0 V0 h1 v0.402 c0,0,0,0,0,0 C0.982,0.402,0.968,0.446,0.968,0.5"
    }
  })])]), _c('svg', {
    staticClass: "svg position-absolute",
    staticStyle: {
      "height": "0"
    }
  }, [_c('clipPath', {
    attrs: {
      "id": "my-clip-path-lg",
      "clipPathUnits": "objectBoundingBox"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.983,0.5 c0,0.054,0.007,0.098,0.017,0.098 c0,0,0,0,0,0 V1 H0 V0 h1 v0.402 c0,0,0,0,0,0 C0.991,0.402,0.983,0.446,0.983,0.5"
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }